import React from "react";
import { Popover, ConfigProvider } from "antd";

import { Colors } from "../../config";

const ChatbotPopover = (props) => {
  const content = props?.content;
  return (
    <ConfigProvider
      theme={{
        token: {
          colorBgElevated: "white",
          colorText: "black",
          controlItemBgHover: Colors.LightSecondary,
          borderRadius: 24,
        },
      }}
    >
      <Popover
        placement={props?.placement || "leftTop"}
        title={props?.title ?? null}
        content={content}
        arrow={{ pointAtCenter: true }}
        defaultOpen={true}
        trigger={props?.trigger ?? "click"}
      >
        {props?.children}
      </Popover>
    </ConfigProvider>
  );
};

export default ChatbotPopover;
